module.exports = __webpack_public_path__ + "static/flags/FP-8086b8c535771545973b7ca2da84cdc0.gif";